import axios from 'axios'
import errorComposer from './errorComposer'

// axios.defaults.timeout = 20000

axios.interceptors.response.use(undefined, function(error) {
    error.handleGlobally = errorComposer(error)

    return Promise.reject(error)
})
